import { memo } from 'react';
import { Link } from 'react-router';
import clsx from 'clsx';

import { routesConfig } from '../../../../routes.config';

import styles from './styles/hero.module.css';

export default memo(Hero);

function Hero() {
	return (
		<section className={clsx(styles['hero'])}>
			<div className={clsx(styles['hero__container'])}>
				<h1 className={clsx(styles['hero__title'])}>Glass2Melt</h1>
				<p className={clsx(styles['hero__description'])}>
					Explore and predict high-pressure refractive index and
					density datasets for silicate, carbonate, oxide, and
					halogenated glasses and crystalline materials. Filter by
					class, compound, and reference—visualize results, run
					predictions, or download the data for research.
				</p>
				<div className={clsx(styles['hero__cte-buttons'])}>
					<Link
						className={clsx(
							styles['hero__cte-button'],
							styles['hero__cte-button-discover'],
						)}
						to={`/${routesConfig.propertyViewer.path}`}
						aria-label="Discover high pressure refractive index and density in the Property Viewer"
					>
						Discover
					</Link>
					<Link
						className={clsx(
							styles['hero__cte-button'],
							styles['hero__cte-button-predict'],
						)}
						to={`/${routesConfig.propertyCalculator.path}`}
						aria-label="Predict high pressure refractive index in the Property Predictor."
					>
						Predict
					</Link>
				</div>
			</div>
		</section>
	);
}
